import type { Product } from "@/types"

/**
 * Resolve the Shopify variant ID for `<nosto-dynamic-card variant-id="...">` preselection.
 *
 * Preference chain:
 *
 *   1. `product.variantId`
 *   2. `product.skus[0].id`
 *   3. `product.realVariantIds[0]`
 *
 * Live Dickies Nosto hits (`docs/live-data-validation/variant-source-summary.json`) usually omit `variantId`
 * but expose Shopify-aligned IDs on `skus[0].id`. Shopify Section Rendering ignores unknown variant IDs gracefully.
 */
export function getVariantId(product: Product): string | undefined {
  return product.variantId ?? product.skus?.[0]?.id ?? product.realVariantIds?.[0] ?? undefined
}
